import React, { Component } from 'react';

import { StyleSheet, View, Keyboard, ScrollView } from 'react-native';

import Modal from './shared/Modal';
import Button from './shared/Button';
import { TextInputLabel } from './shared/TextInput';

import appStore from '../stores/app';

import { signUp, uniqLogin, signUpQuick, signUpQuickFB } from '../lib/userApiCalls';
import { t } from '../utils/appUtils';

import { ERRORS, IS_WEB } from '../lib/appConstants';
import { MARGIN_15, pOrT } from './styleConstants';
import { BottomLabel } from './SignInScreen';

import heroStore from '../stores/hero';
import authStore from '../stores/auth';

import log from '../lib/log';

const LOGIN_PATTERN = /^[a-zA-Zа-яА-Я0-9._-]*$/;
export const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

const MARGIN = MARGIN_15;

// const TABLET_FORM_HEIGHT = 380;
// const TABLET_TOP_OFFSET = Math.min(
//   (WINDOW_HEIGHT - TABLET_FORM_HEIGHT) / 2,
//   300,
// );

// const LONG_FORM_WIDTH = pOrT(270, FORM_WIDTH);

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  button: {
    marginTop: MARGIN,
  },
});

type Props = {
  isFB?: boolean;
  onHide: Function;
  quick?: boolean;
};

type State = {
  isFB?: boolean;
  login: string;
  email: string;
  password: string;
};

export default class SignUpModal extends Component<Props, State> {
  inputs: Record<string, any> = {};

  constructor(props: Props) {
    super(props);
    const { quick, isFB } = props;

    this.state = {
      isFB,
      login: quick ? heroStore.hero.login : '',
      email: quick ? authStore.user.email : '',
      password: '',
    };
  }

  onChangeInput(key: string, value: string) {
    this.setState({
      [key]: value,
    } as any);
  }

  onSubmit = async () => {
    appStore.toggleLoading(true);

    const { onHide } = this.props;

    const { password } = this.state;
    let { login, email } = this.state;

    login = login.trim();
    email = email.trim();

    const validateMsg = await this.validate({ login, email, password });

    if (validateMsg) {
      appStore.toggleLoading(false);
      appStore.showMessage({ type: 'error', text: validateMsg });
      return;
    }

    const { isFB } = this.state;
    const { quick } = this.props;

    Keyboard.dismiss();
    if (quick) {
      if (!isFB) {
        try {
          await signUpQuick(authStore.user, email, password, { login });
          (log as any)('SignUpQuick', { email });
        } catch (e) {
          appStore.toggleLoading(false);
          appStore.showMessage({ type: 'error', text: (e as any).message });
          return;
        }
      } else {
        let result;
        try {
          result = await signUpQuickFB(authStore.user, { login });
          (log as any)('SignUpQuickFB');
        } catch (e) {
          appStore.toggleLoading(false);
          appStore.showMessage({
            type: 'error',
            text:
              {
                [ERRORS.CREDENTIAL_ALREADY_IN_USE]: t('auth.alreadyAssociated'),
              }[(e as any).code] || (e as any).message,
          });
          return;
        }

        if (result === false) {
          appStore.toggleLoading(false);
          return;
        }
      }

      appStore.toggleLoading(false);
      onHide();
      appStore.showMessage({
        type: 'success',
        text: t('auth.signUpQuickSuccess'),
      });
    } else if (!isFB) {
      try {
        await signUp(email, password);
        (log as any)('SignUpAction', { email });
      } catch (e) {
        appStore.toggleLoading(false);
        appStore.showMessage({
          type: 'error',
          text:
            {
              [ERRORS.EMAIL_IN_USE]: t('auth.emailAlreadyTaken'),
            }[(e as any).code] || (e as any).message,
        });
        return;
      }

      onHide({ email, password, data: { login } });
    } else {
      onHide({ data: { login } });
    }
  };

  async validate({ login, email, password }: any) {
    const { quick } = this.props;
    const { isFB } = this.state;

    async function validateLogin() {
      if (!LOGIN_PATTERN.test(login)) {
        return t('auth.loginNotMatchPattern');
      }

      let result = await uniqLogin(login);
      if (quick && result && result.id === authStore.user.uid) result = null;
      if (result) return t('auth.loginExists');

      return null;
    }

    if (!isFB) {
      if (!login || !email || !password) {
        return t('auth.allFieldsRequired');
      }

      if (!EMAIL_PATTERN.test(email)) return t('auth.emailInvalid');
      const loginError = await validateLogin();
      if (loginError) return loginError;

      if (password.length < 6) return t('auth.passwordLeast6Chars');
    } else {
      if (!login) {
        return t('auth.loginRequired');
      }

      const loginError = await validateLogin();
      if (loginError) return loginError;
    }

    return null;
  }

  focusNextField(id: string) {
    (this.inputs as any)[id].focus();
  }

  render() {
    const { onHide, quick } = this.props;
    const { isFB, login, email, password } = this.state;

    return (
      <Modal title={t('auth.signUp')} onHide={onHide}>
        <View style={styles.container}>
          <View>
            {/* $FlowFixMe */}
            <ScrollView
              style={{
                height: pOrT(170, 200),
                width: '100%',
              }}
              contentContainerStyle={{
                alignItems: 'center',
                paddingBottom: IS_WEB ? 0 : 100,
              }}
            >
              <TextInputLabel
                label={t('auth.login').toUpperCase()}
                maxLength={15}
                value={login}
                autoCapitalize="none"
                returnKeyType={isFB ? 'done' : 'next'}
                onSubmitEditing={
                  isFB
                    ? this.onSubmit
                    : () => {
                        this.focusNextField('email');
                      }
                }
                onChangeText={(value: string) => this.onChangeInput('login', value)}
                testID="signUp.fields.login"
              />

              {!isFB ? (
                <TextInputLabel
                  label={t('auth.email').toUpperCase()}
                  maxLength={30}
                  style={[{ marginTop: MARGIN }]}
                  value={email}
                  autoCapitalize="none"
                  returnKeyType="next"
                  inputRef={(ref: any) => {
                    this.inputs.email = ref;
                  }}
                  onSubmitEditing={() => {
                    this.focusNextField('password');
                  }}
                  onChangeText={(value: string) => this.onChangeInput('email', value)}
                  testID="signUp.fields.email"
                />
              ) : null}

              {!isFB ? (
                <TextInputLabel
                  label={t('auth.password').toUpperCase()}
                  secureTextEntry
                  maxLength={15}
                  autoCapitalize="none"
                  returnKeyType="done"
                  onSubmitEditing={this.onSubmit}
                  style={[{ marginTop: MARGIN }]}
                  inputRef={(ref: any) => {
                    this.inputs.password = ref;
                  }}
                  value={password}
                  onChangeText={(value: string) => this.onChangeInput('password', value)}
                  testID="signUp.fields.password"
                />
              ) : null}
            </ScrollView>
            <View style={{ alignItems: 'center' }}>
              <Button
                style={styles.button}
                size="large"
                onPress={this.onSubmit}
                testID="signUp.submit"
              >
                {!quick
                  ? t('auth.create')
                  : !isFB
                  ? t('auth.signUpQuick')
                  : t('auth.signUpQuickWithFB')}
              </Button>

              {!isFB && !quick ? (
                <BottomLabel
                  leftText={t('auth.alreadyAccount')}
                  rightText={t('auth.signIn')}
                  onPress={onHide as any}
                />
              ) : null}
            </View>
          </View>
        </View>
      </Modal>
    );
  }
}
